import { render } from "./ProjectAutocomplete.vue?vue&type=template&id=037c7e9a&scoped=true"
import script from "./ProjectAutocomplete.vue?vue&type=script&lang=js"
export * from "./ProjectAutocomplete.vue?vue&type=script&lang=js"

import "./ProjectAutocomplete.vue?vue&type=style&index=0&id=037c7e9a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Azize HRM\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037c7e9a"]])

export default __exports__